/**
 * The served file's own size in bytes, on a serve response that carries no usable
 * Content-Range / Content-Length — the buffered HTML / SVG / live-content path ignores
 * Range and streams chunked. Written by the serve route, read by the share view's byte
 * probe to apply an editor's size limit (#942: HTML over 1 MB opens preview-only).
 */
export const SERVED_FILE_SIZE_HEADER = 'X-Papan-File-Size'

/**
 * #1095: on a `?papanRaw=1` read of `/s/` the body is the SAVED file's bytes, unrewritten, served as `text/plain` (so the
 * preview origin never renders or runs them); this header carries the type the file is served
 * with otherwise, so the share view can type its Blob (an SVG the image viewer shows needs
 * `image/svg+xml`). A label for the client's Blob — never a Content-Type the browser acts on.
 */
export const SERVED_FILE_TYPE_HEADER = 'X-Papan-File-Type'

/**
 * #1095: the `/s/` query flag that asks for the file's bytes, unrewritten and inert. Namespaced, like
 * `papanProbe`: `/s/` also serves an app page's OWN sub-resource requests, and a generic `raw=1`
 * there (`lib.js?raw=1`) would turn the app's script into inert text.
 */
export const RAW_READ_QUERY_PARAM = 'papanRaw'
